import { useFlags } from 'launchdarkly-react-client-sdk';

import { LD } from 'src/app/constants/launch-darkly-flags';

export function useIntelligenceCenterEnabled() {
  const flags = useFlags();
  return flags[LD.INTELLIGENCE_CENTER] ?? false;
}
